import type { FunctionComponent } from "react";
import { ReleaseEarningsModalPartial } from "../../../../partials/admin/menus/campaign/release-earnings-modal.admin.partials";

export const ReleaseEarningsModalAdminScreen: FunctionComponent = () => {
	return <ReleaseEarningsModalPartial />;
};
